import { useWrite, HookshotError } from '@bw/hookshot';

import config from 'utils/config';

type UseSendTNVerificationCode = {
  input: {
    email: string;
    phoneNumber: string;
    code: string;
  };
};

export interface SendTNVerificationResponse {
  message: string;
  status: string;
  registrationId: string;
}

export const useSendTNVerificationCode = () => {
  return useWrite<UseSendTNVerificationCode, SendTNVerificationResponse>(
    `${config.kongBaseUrl}/v1/express/registration/code/verify`,
    'POST',
    {
      requestFormat: 'json',
      fetchOptions: {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      transformError: (err) =>
        err
          ? new HookshotError(err.response, err.data?.errors?.[0]?.description)
          : err,
    },
  );
};
